"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Content_module_1 = tslib_1.__importDefault(require("./modules/Content.module"));
const Url_module_1 = tslib_1.__importDefault(require("./modules/Url.module"));
const FilterModule_1 = tslib_1.__importDefault(require("./modules/FilterModule"));
const loadContentTileListerModule = (initialData) => ({
    hasRouter: true,
    modules: [(0, Content_module_1.default)(initialData), (0, Url_module_1.default)(initialData), (0, FilterModule_1.default)(initialData)],
});
exports.default = loadContentTileListerModule;
